<template>
  <div>
    <user-warning-message
      :users="[{
        id: audit.auditeurId,
        msg: 'utilisateur.warning.auditeurArchive'
      }]"/>
    <div class="card">
      <header class="header-card">
        <p>{{ $t('detailAudit.infoGenerale.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field :label="$t('detailAudit.infoGenerale.titre')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ audit.titre }}
            </span>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('detailAudit.infoGenerale.dateSouhaite')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ audit.dateSouhaitee | formatDate }}
            </span>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('detailAudit.infoGenerale.datePlanification')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ audit.datePlanification | formatDate }}
            </span>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('detailAudit.infoGenerale.dateRealisation')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ audit.dateRealisation | formatDate }}
            </span>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('detailAudit.infoGenerale.auditeur')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ getNomAuditeur }}
            </span>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field :label="$t('detailAudit.infoGenerale.agence')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
                {{ getLibelleAgence }}
            </span>
            </b-field>
          </div>
          <div class="column is-12">
            <b-field :label="$t('detailAudit.infoGenerale.description')"
                     custom-class="has-text-weight-normal is-italic is-marginless">
            <span class="has-text-weight-bold">
              {{ audit.description }}
            </span>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>
          {{ $t('detailAudit.infoGenerale.pj')}}
        </p>
      </header>
      <div class="card-content">
        <pieces-jointes readOnly
                        deletable
                        autoSave
                        :checkPermissions=checkPermissions(constantes.ORDRE_TRAVAIL_AUDIT.maj)
        />
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import PiecesJointes from '@/components/general/piecesJointes';
import userWarningMessage from '@/components/commun/user/userWarningMessage';
import { ORDRE_TRAVAIL_AUDIT } from '@/configuration/logistique/permissionsLogistiqueConf';

const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');

export default {
  name: 'LogistiqueAuditDetailAudit',
  props: {
    audit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        ORDRE_TRAVAIL_AUDIT,
      },
    };
  },
  components: {
    PiecesJointes,
    userWarningMessage,
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    getNomAuditeur() {
      const userFind = this.parametre(PARAMETRES_KEYS.utilisateur).find((user) => {
        return user.id === this.audit.auditeurId;
      });
      return userFind?.decorator?.nomPrenom || null;
    },
    getLibelleAgence() {
      const agenceFind = this.user.agences.find((agence) => {
        return agence.agenceId === this.audit.agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
  },
};

</script>
